import $ from 'jquery';
import {create as createInstitution} from './institution';

// checks whether the relevant field is on the page before running
if ($('[data-js-invite-institution]').length) {
    var instituteInvite = {

        init: function() {
            this.role = $('[name="role_uid"]');
            this.pharmacyRole = $('[data-institution="1"]');
            this.$regions = $("[name$='regions[]']");
            this.institutionField = $('[data-js="institution-field"]');
            this.institutionInput = $('[data-js="invite-institution"]');

            this.eventHandlers();

            this.inviteInstitution = createInstitution($('[data-js-invite-institution]'));
            this.inviteInstitution.changeRegion(this.$regions.val(),false);
        },

        eventHandlers: function() {
            this.role.on('change',this.manageChosen.bind(this));
            this.role.on('change',this.manageInstField.bind(this));
            this.$regions.on('change',this.changeInstRegion.bind(this));
        },

        isPharmacy: function() {
            return this.role.val() === this.pharmacyRole.val();
        },

        manageInstField: function() {
            if (this.isPharmacy()) {
                this.institutionField.removeAttr('hidden');
            } else {
                this.institutionField.attr('hidden','hidden');
            }
        },

        manageChosen: function() {
            if (this.$regions.attr('multiple')) {
                this.singleRegion();
            } else {
                this.reInitChosen();
            }
        },

        singleRegion: function() {
            if (this.isPharmacy()) {
                this.$regions[0].selectize.destroy();
                this.$regions.removeAttr('multiple');
                this.changeInstRegion();
            }
        },

        reInitChosen: function() {
            this.$regions.attr('multiple','multiple');
            this.$regions.selectize();
        },

        changeInstRegion: function() {

            if(this.isPharmacy()) {
                this.institutionInput.val('');
                this.inviteInstitution.changeRegion(this.$regions.val(),true)
            }

        }

    }

    $(document).ready(()=>{
        instituteInvite.init();
    })
}
